import { JSX } from 'react';

const IconCarouselArrowLeft = (): JSX.Element => {
  return (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.5893 3.57739C10.9147 3.90283 10.9147 4.43047 10.5893 4.7559L6.17855 9.16665H15.8334C16.2936 9.16665 16.6667 9.53974 16.6667 9.99998C16.6667 10.4602 16.2936 10.8333 15.8334 10.8333H6.17855L10.5893 15.2441C10.9147 15.5695 10.9147 16.0971 10.5893 16.4226C10.2639 16.748 9.73622 16.748 9.41079 16.4226L3.57745 10.5892C3.25201 10.2638 3.25201 9.73616 3.57745 9.41072L9.41079 3.57739C9.73622 3.25195 10.2639 3.25195 10.5893 3.57739Z"
        fill="currentColor"
      />
    </>
  );
};

export default IconCarouselArrowLeft;
